<template>
  <v-text-field
    rounded
    outlined
    clearable
    data-private
    dense
    background-color="white"
    hide-details
    class="searchBar body-2"
    prepend-inner-icon="mdi-magnify"
    :disabled="disabled"
    :placeholder="placeholder || $t('search.search_placeholder')"
    :value="terms"
    @input="onSearch"
    @click:clear="$emit('clearSearch')"
  >
  </v-text-field>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Search',

  props: {
    placeholder: {
      type: String,
      required: false,
    },

    disabled: {
      type: Boolean,
    },

    terms: {
      type: String,
      required: true,
    },
  },

  methods: {
    onSearch: _.debounce(function(terms) {
      this.$emit('search', terms)
    }, 700),
  },
}
</script>
<style>
.searchBar .v-input__control .v-input__slot {
  padding-left: 8px;
}

.searchBar .v-input__icon .v-icon {
  height: 20px;
  width: 20px;
  font-size: 20px;
}
</style>
